import { StyleSheet } from 'react-native';
import { GREY_COLOR, WHITE_COLOR } from '../../styles/common';

const FOOTER_BACKGROUND_COLOR = '#EEEEF0';
const BOTTOM_BAR_BACKGROUND_COLOR = '#6E7482';

const styles = StyleSheet.create({
    wrapper: {
        backgroundColor: FOOTER_BACKGROUND_COLOR,
        display: 'flex',
        flexDirection: 'row',
    },
    wrapper_phone: {
        backgroundColor: FOOTER_BACKGROUND_COLOR,
        display: 'flex',
        flexDirection: 'column',
    },
    col_styles: {
        flex: 1,
        marginVertical: 8,
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 40,
    },
    col_styles_phone: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 24,
        marginVertical: 4,
    },
    pressable_styles: {
        marginBottom: 40,
    },
    main_link_text_styles: {
        color: GREY_COLOR,
        fontSize: 18,
        fontFamily: 'Open Sans',
        fontWeight: 400,
        textAlign: 'center',
    },
    logo: {
        width: 158,
    },
    bottomBar: {
        backgroundColor: BOTTOM_BAR_BACKGROUND_COLOR,
        height: 47,
        paddingLeft: 55,
        paddingRight: 40,
        justifyContent: 'center',
        flexDirection: 'row',
    },
    bottomBarMobile: {
        backgroundColor: BOTTOM_BAR_BACKGROUND_COLOR,
        alignItems: 'center',
        flexDirection: 'column',
    },
    bottomBarText: {
        fontFamily: 'Open Sans',
        color: WHITE_COLOR,
        fontSize: 14,
        fontWeight: 400,
    },
    bottomBarTextMobile: {
        fontFamily: 'Open Sans',
        color: WHITE_COLOR,
        fontSize: 14,
        fontWeight: 400,
        paddingBottom: 10,
    },
    bottomColumn: {
        flex: 1,
        justifyContent: 'center',
    },
    bottomColumnMobile: {
        marginVertical: 4,
        paddingHorizontal: 15,
    },
    bottomColumnIcons: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    bottomColumnIconsMobile: {
        marginVertical: 4,
        paddingHorizontal: 15,
        order: -1,
        flexDirection: 'row',
        justifyContent: 'center',
    },
});

export default styles;
